module.exports = __webpack_public_path__ + "img/chevron-down.2b1562d0.svg";